import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class ToggleCustomerProfileArchive extends ModelBase {
    clientId : number = 0;

    customerProfileId : number = 0; 

    isArchive : boolean = false;
}